import styled from 'styled-components';

export const RootLogoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 26px;

  @media (max-width: 480px) {
    padding-left: 30px;
    padding-right: 30px;
  }

  @media (min-width: 960px) {
    width: 50%;
    padding: 10px 40px 10px 10px;
  }

  @media (min-width: 1200px) {
    gap: 16px;
    padding: 20px;
  }
`;

export const RootLogos = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 32px;

  @media (min-width: 1200px) {
    gap: 16px 32px;
  }
`;

RootLogoBox.displayName = 'RootLogoBox';
RootLogos.displayName = 'RootLogos';
